"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSRError = exports.ErrorCodesPipelineClassicSignRequirements = void 0;
const error_1 = require("../../../../stellar-plus/error");
const transaction_1 = require("../../../../stellar-plus/error/helpers/transaction");
var ErrorCodesPipelineClassicSignRequirements;
(function (ErrorCodesPipelineClassicSignRequirements) {
    // PBT0 General
    ErrorCodesPipelineClassicSignRequirements["CSR001"] = "CSR001";
})(ErrorCodesPipelineClassicSignRequirements || (exports.ErrorCodesPipelineClassicSignRequirements = ErrorCodesPipelineClassicSignRequirements = {}));
const processFailed = (error, conveyorBeltErrorMeta, transaction) => {
    return new error_1.StellarPlusError({
        code: ErrorCodesPipelineClassicSignRequirements.CSR001,
        message: 'An issue occurred while processing the classic sign requirements.',
        source: 'PipelineClassicSignRequirements',
        details: "An issue occurred while processing the classic sign requirements. Review the transaction object and the operations' parameters.",
        meta: {
            error,
            conveyorBeltErrorMeta,
            transactionData: (0, transaction_1.extractTransactionData)(transaction),
        },
    });
};
exports.CSRError = {
    processFailed,
};
